export const DEFAULT_PAGE_LOAD_SIZE = 100;
